import { render } from "./AppPopup.vue?vue&type=template&id=e44c236e"
import script from "./AppPopup.vue?vue&type=script&lang=js"
export * from "./AppPopup.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__